import { Component, inject } from '@angular/core';
import { Location } from '@angular/common';
import { AuthService } from '@auth0/auth0-angular';
import { AdminAuthService } from '../../services/auth/admin-auth.service';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'bodyanalytics-logout-button',
  templateUrl: './logout-button.component.html',
  imports: [MatIconModule, MatButtonModule],
})
export class LogoutButtonComponent {
  protected auth = inject(AuthService);
  protected location = inject(Location);
  private adminAuthService = inject(AdminAuthService);

  logout() {
    // Clear admin tenant info before logout
    this.adminAuthService.clearAdminTenantInfo();
    // #1257 — return to this app's own origin (must be in Auth0 "Allowed Logout
    // URLs") instead of Auth0's default, which routed customers to the calendar app.
    this.auth.logout({ logoutParams: { returnTo: window.location.origin }, openUrl: url => location.replace(url) });
  }
}
